import { Component, OnInit, Input} from '@angular/core';
import { ApiService } from '../api.service';
import { FormGroup, FormControl, FormBuilder, FormArray, Validators, FormGroupDirective } from '@angular/forms';
import { ObservablesService } from '../observables.service';
import {Router} from "@angular/router";
import { DatePipe } from '@angular/common';
import {MAT_MOMENT_DATE_FORMATS, MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports
import {default as _rollupMoment} from 'moment';

const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@Component({
  selector: 'app-slip-to-invoice-form',
  templateUrl: './slip-to-invoice-form.component.html',
  styleUrls: ['./slip-to-invoice-form.component.scss'],
  providers: [
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
 ],
})
export class SlipToInvoiceFormComponent implements OnInit {
  saveSuccess: boolean;
  saveUnsuccess: boolean;
  selectedSlip:any=[];
  existingInvoiceStatus:boolean = false;
  slipToInvice: FormGroup;
  total: any;

  sum: number=0;
  value1: number;
  value2: number;
  loggedUserInfo:any=[];
  user_id:any;
  gst_total_amount:any=0;
  exclude_gst_total_amount:any=0;

  constructor(private observables:ObservablesService, private datePipe: DatePipe,private formBuilder: FormBuilder,private api:ApiService,private router: Router) {
    if(this.router.getCurrentNavigation().extras.state !== undefined){

      this.selectedSlip = this.router.getCurrentNavigation().extras.state.data
      this.user_id = this.router.getCurrentNavigation().extras.state.user_id
      // console.log("selectd slip==",this.selectedSlip)
    }
  }

  ngOnInit() {
    this.gst_total_amount = 0;
    this.exclude_gst_total_amount = 0;
    // this.gst_total_amount = this.gst_total_amount + this.s
    // this.exclude_gst_total_amount = this.exclude_gst_total_amount + this.s
    this.sum = this.sum + this.selectedSlip.reduce( ( accumulator, currentValue ) => {
      this.gst_total_amount = this.gst_total_amount + currentValue.gst_total_amount;
      this.exclude_gst_total_amount = this.exclude_gst_total_amount + currentValue.total_amount;
      return accumulator +Math.round((( currentValue.total_amount + currentValue.gst_total_amount)) * 100) / 100;
    }, 0);

    let date:any = new Date();
    let slip_date:any=this.datePipe.transform(date, 'yyyy-MM-dd');
    this.slipToInvice = this.formBuilder.group({
      invoice_number:['', Validators.compose([Validators.required,Validators.pattern(/^[0-9]{1,6}$/)])],
      invoice_date:[{value:moment(),disabled:true}, Validators.required],
      total_amount:this.sum.toFixed(2)
    });

    this.api.getLoggedUserInfo().then((res:any)=>{
      if(res.data.length > 0){
        this.loggedUserInfo = res.data[0];
        this.getLastInvoiceId()
      }else{
        this.api.logOut()
      }
    })
  }

  submitData(value,formDirective:FormGroupDirective){
    value = this.slipToInvice.getRawValue()
    let date:any = new Date(value.invoice_date);
    // let invoice_date:any = date.getFullYear()+"-"+(date.getMonth()+1)+"-"+date.getDate();
    let invoice_date:any=this.datePipe.transform(date, 'yyyy-MM-dd');

    // console.log("value=",value)
    // console.log("selectedSlip=",this.selectedSlip)

    this.api.send("insertDb",{
      table:"master_invoices",
      data:{
        business_id:this.loggedUserInfo.business_id,
        invoice_number:value.invoice_number,
        party_id:this.selectedSlip[0].party_id,
        party_name:this.selectedSlip[0].party_name,
        gstin:this.selectedSlip[0].gstin,
        invoice_date:invoice_date,
        user_id:this.user_id,
        user_name:this.loggedUserInfo.username,
        gst_total_amount:this.gst_total_amount,
        exclude_gst_total_amount: this.exclude_gst_total_amount,
        total_amount: value.total_amount,
        balance:value.total_amount,
        paid_status:'0',
        slip_status:1,
        direct_invoice_status:this.selectedSlip[0].direct_slip_status,
        tags:this.selectedSlip[0].tags,
        note:this.selectedSlip[0].note,
        delivery_to: this.selectedSlip[0].delivery_to
      }
    }).then((result:any)=>{
      // console.log("result==",result)
      if(result.data.affectedRows){

        for(let i=0;i<this.selectedSlip.length;i++)
        {

          this.api.send("updateDb",{
            table:"master_slips",
            data:{
              invoice_status:1,
              master_invoice_id:result.data.insertId
            },
            conditions:[{id:this.selectedSlip[i].id}]
          }).then((result1:any)=>{
            // console.log("result=",result1)
            if(result1.data.affectedRows){
              if(this.selectedSlip[0].direct_slip_status == 0){

                this.updateProductDetails(this.selectedSlip[i].id,result.data.insertId).then((productUpdateRes:any)=>{

                  this.saveSuccess = true;
                  this.saveUnsuccess = false;
                  formDirective.resetForm();
                  this.slipToInvice.reset();
                  this.observables.showToastMessage({type:0, message:"Invoice Created Successfully"})
                  this.router.navigate([this.api.getRoute(this.loggedUserInfo.level,'/dashboard')])
                })
              }else{
                this.saveSuccess = true;
                this.saveUnsuccess = false;
                formDirective.resetForm();
                this.slipToInvice.reset();
                this.observables.showToastMessage({type:0, message:"Invoice Created Successfully"})
                this.router.navigate([this.api.getRoute(this.loggedUserInfo.level,'/dashboard')])

              }
            }else{

              this.api.send("deleteDb",{
                table:"master_invoices",
                conditions:[{id:result.data.insertId}]
              }).then((res1:any)=>{
                this.saveUnsuccess = true;
                this.saveSuccess = false;

              })



            }
          })
        }
      }else{
        this.saveUnsuccess = true;
        this.saveSuccess = false;
      }
    })
  }

  updateProductDetails(slip_id,invoice_id){
    return new Promise((resolve)=>{
      this.api.send("updateDb",{
        table:"master_slip_products",
        data:{
          master_invoice_id:invoice_id
        },
        conditions:[{master_slip_id:slip_id}]
      }).then((result1:any)=>{
        // console.log("result==",result1)
        resolve(true)

      })
    })
  }

  getLastInvoiceId(){
    this.api.send("findDb",{
      fields:["invoice_number"],
      table:"master_invoices",
      conditions:[{business_id:this.loggedUserInfo.business_id}],
      order:"invoice_number DESC",
      limit:1
    }).then((res:any)=>{
      if(res.data.length > 0){

        this.slipToInvice.patchValue({invoice_number:parseInt(res.data[0].invoice_number) + 1})
      }else{
        this.slipToInvice.patchValue({invoice_number:1})
      }
    })
  }



  checkInvoiceNo(value){
    // console.log("Inoive no= : ",event.target.value);
    if(value.length > 0){
      let data={
        invoice_number:value,
        business_id:this.loggedUserInfo.business_id
      }

      this.api.send("findDb",{
        table:"master_invoices",
        conditions:[data]
      }).then((result:any)=>{
        // console.log("Invoice No==",result)
        if(result.data.length > 0){

          this.existingInvoiceStatus = true;
          // resolve(true)
        }else{
          this.existingInvoiceStatus = false;
          // resolve(false)
        }
      })
    }else{
      this.existingInvoiceStatus = false;
      // resolve(false)
    }


  }



}
